import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { Salida, SalidasRespSchema } from '../data/schemas/salida.schema';
import { Plant } from '../data/schemas/session.schema';

/** Planta activa, cosecha y rango de fechas (`YYYY-MM-DD`) obligatorios, y turno buscado. */
export interface SalidaFiltro {
  contexto: Pick<Plant, 'companyCode' | 'plantCode'>;
  cosecha: number;
  desde: string;
  hasta: string;
  turno?: number;
}

/** Salidas al campo. */
export abstract class SalidaDataService {
  abstract salidas(filtro: SalidaFiltro): Observable<Salida[]>;
}

/**
 * Implementación real: `GET /seed-backoffice/salida`, validado con Zod y sin fallback.
 * Siempre envía la cosecha: con fechas solas el WS supera el timeout.
 */
@Injectable()
export class SalidaApiService extends SalidaDataService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/seed-backoffice/salida`;

  salidas({ contexto, cosecha, desde, hasta, turno }: SalidaFiltro): Observable<Salida[]> {
    let params = new HttpParams()
      .set('Empresa_Codigo', contexto.companyCode)
      .set('Planta_Codigo', contexto.plantCode)
      .set('PLote_Cosecha', cosecha)
      .set('FechaDesde', desde)
      .set('FechaHasta', hasta);
    if (turno != null) params = params.set('PDespa_Turno', turno);
    return this.http.get<unknown>(this.url, { params }).pipe(map((res) => SalidasRespSchema.parse(res)));
  }
}
